import UtilsFncs from "utils/UtilsFncs";

export const brandOptions = [
  { value: 1, name: "Karsten" },
  { value: 2, name: "Trussardi" },
  { value: 3, name: "Karsten Decor" },
];

export function mapBrandFromApi(marca) {
  return brandOptions.find((b) => b.value === marca) ?? null;
}

export function mapPaymentFromDetail(condicoes, paymentOptions) {
  const list = condicoes?.length ? condicoes : [];
  return list
    .map((c) => {
      const found = paymentOptions?.find(
        (p) => p.IdCondicaoPagamento === c.IdCondicaoPagamento,
      );
      if (found) return found;
      const politica = c.Politica ?? "";
      const pct = c.PercentualDesconto ?? "";
      return {
        ...c,
        displayLabel: politica
          ? `${politica} · Desconto: ${pct}%`
          : `Condição ${c.IdCondicaoPagamento}`,
      };
    })
    .filter(Boolean);
}

export function mapPriceTablesFromDetail(codigosOrTabelas, priceTableOptions) {
  const sourceItems = Array.isArray(codigosOrTabelas) ? codigosOrTabelas : [];
  if (!sourceItems.length) return [];

  const normalized = sourceItems.map((item) => {
    if (item != null && typeof item === "object") {
      const cod = item.CodigoTabelaPreco ?? item.CodTabelaPreco;
      return {
        cod: cod != null ? String(cod).trim() : "",
        desc: (item.Descricao ?? item.Nome ?? "").trim(),
      };
    }
    return { cod: String(item).trim(), desc: "" };
  });

  return normalized
    .filter((entry) => entry.cod)
    .map(({ cod, desc }) => {
      const found = priceTableOptions?.find(
        (p) => String(p.CodTabelaPreco) === cod,
      );
      if (found) return found;
      const displayLabel = desc ? `${cod} · ${desc}` : cod;
      return {
        CodTabelaPreco: cod,
        Descricao: desc,
        displayLabel,
      };
    });
}

export function buildShowcasePayload(
  formData,
  selectedProducts,
  representatives = [],
) {
  const idsCondicaoPagamento = (formData.paymentConditions ?? [])
    .map((c) => c.IdCondicaoPagamento)
    .filter(Boolean);

  const codigosTabelaPreco = (formData.priceTables ?? [])
    .map((t) => parseInt(t.CodTabelaPreco, 10))
    .filter((n) => !Number.isNaN(n) && n > 0);

  const firstPayment =
    formData.paymentConditions?.[0] ?? formData.paymentCondition;

  const idsRepresentante = (representatives ?? [])
    .map((r) => r.Id)
    .filter(Boolean)
    .join(",");

  return {
    nome: formData.name,
    descricao: formData.description ?? "",
    ativo: true,
    marca: formData.brand?.value,
    dataVigenciaInicio: formData.untilSoldOut
      ? null
      : UtilsFncs.ConvertDateFormat(formData?.initialDate, "-", "-"),
    dataVigenciaFim: formData.untilSoldOut
      ? null
      : UtilsFncs.ConvertDateFormat(formData?.finalDate, "-", "-"),
    finalizarEstoque: formData.untilSoldOut,
    codigoTabelaPreco:
      codigosTabelaPreco[0] ?? formData.priceTable?.CodTabelaPreco ?? null,
    codigosTabelaPreco,
    descricaoTabelaPreco:
      formData.priceTables?.[0]?.Descricao ??
      formData.priceTable?.Descricao ??
      null,
    idCondicaoPagamento: firstPayment?.IdCondicaoPagamento,
    idsCondicaoPagamento,
    prazoMedio: firstPayment?.PrazoMedio
      ? `${firstPayment.PrazoMedio} dias`
      : `${formData.paymentCondition?.PrazoMedio ?? ""} dias`,
    valorMinimo: formData.minimumValue,
    duplicataMinima: formData.minimumInvoice,
    quantidadeMinimaPedido: formData.minimumQuantityPerOrder,
    porLinha: formData.byLine,
    porPedido: formData.byOrder,
    itensProduto: selectedProducts.map((product) => ({
      idProduto: product.Codigo,
      descontoPercentual: product?.Desconto || 0,
    })),
    idsRepresentante,
  };
}
